var map = {
	"./akar-icons.json": 74089,
	"./app.json": 1008,
	"./bx.json": 26331,
	"./bxs.json": 60064,
	"./bytesize.json": 73262,
	"./carbon.json": 48392,
	"./ci.json": 25665,
	"./cib.json": 29081,
	"./cil.json": 94763,
	"./clarity.json": 41907,
	"./devicon.json": 22133,
	"./ei.json": 84279,
	"./eos-icons.json": 15353,
	"./fa6-solid.json": 1224,
	"./gg.json": 22239,
	"./heroicons-outline.json": 63382,
	"./heroicons.json": 24685,
	"./hugeicons.json": 35288,
	"./ic.json": 49101,
	"./la.json": 3574,
	"./line-md.json": 11307,
	"./logos.json": 90423,
	"./lucide.json": 42825,
	"./mdi.json": 61819,
	"./mingcute.json": 18995,
	"./mynaui.json": 4744,
	"./oui.json": 62900,
	"./ph.json": 41485,
	"./pixelarticons.json": 72058,
	"./ri.json": 62040,
	"./simple-icons.json": 64636,
	"./streamline.json": 91547,
	"./svg-spinners.json": 59366,
	"./tabler.json": 3723,
	"./tdesign.json": 46097,
	"./uim.json": 31122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25820;